import React, { useEffect, useState } from "react";
import {
    Button,
    Col,
    Container,
    Form,
    Row,
    Spinner,
    Table,
} from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import Pagination from "../Common/Pagination";
import moment from "moment";
import ExcelIcon from "../../Assets/ExcelIcon.svg"
import * as Icon from "react-bootstrap-icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";

const GatLipikReportAnalysis = () => {
    const selectedFinancialYear = useSelector((state) => state.activeData.financialYear);
    const userState = useSelector(state => state?.loginData?.userData);
    // Variables for Zone-Gat Visitors Data ------------
    const [contractor, setContractor] = useState();
    const [TodayData, setTodayData] = useState();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startDateErr, setStartDateErr] = useState("");
    const [endDateErr, setEndDateErr] = useState("");
    const [loader, setLoader] = useState(false);
    const [currentloader, setCurrentLoader] = useState(false);

    // States for Pagination ----------
    const [pageNo, setPageNo] = useState(1);
    const [docPerPage, setDocPerPage] = useState(50);
    const [noOfPages, setNoOfPages] = useState(0);

    // function for pagination

    const handlePageChange = (pageNumber) => {
        setPageNo(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setPageNo(1);
        setDocPerPage(docsPageProp);
    };

    //   useEffect API Calls
    useEffect(() => {
        getGatLipikReport();
    }, [selectedFinancialYear]);

    // get List API
    const getGatLipikReport = async () => {
        setLoader(true);
        await fetch(
            process.env.REACT_APP_BASE_URL +
            "/billDistribution/gatLipikReport"
            ,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    financialYear: selectedFinancialYear,
                    ...(userState?.usertype_keyname?.includes("zonalofficer") && {
                        zonekey: userState?.zonekey
                    })
                }),
            }
        )
            .then((res) => res.json())
            .then((response) => {
                if (response.status === 200) {
                    console.log("gatlipikrepobse", response);

                    setContractor(response);
                    setNoOfPages(response.noOfPages);

                } else {
                    setLoader(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLoader(false);
            });
    };

    return (
        <div className="visitReport">
            <ToastContainer />
            <Container>
                <Row className="visitors mt-2">
                    <div className="container tbl-container p-0">
                        <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
                            <Table responsive="lg" hover style={{ borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th colSpan={10} className="text-center border-th">
                                            Current Year
                                        </th>

                                    </tr>
                                    <tr>
                                        <th>Sr No.</th>
                                        <th>Name</th>
                                        <th>Contact No</th>
                                        <th>Property Image RejectCount</th>
                                        <th>PropertyNotFound Image RejectCount</th>
                                        <th>IsNotice Image RejectCount</th>
                                        <th>IsMeeting Person Image RejectCount</th>
                                        <th>Property VisitCount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <center>
                                            <Spinner />
                                        </center>
                                    ) : (
                                        contractor && contractor?.data !== undefined && contractor?.data !== null &&
                                            contractor?.data?.length > 0 ?
                                            contractor?.data?.map((row, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className="border-tr-new">
                                                            {pageNo !== 1 ? (
                                                                <> {index + 1 + docPerPage * (pageNo - 1)}</>
                                                            ) : (
                                                                <>{index + 1}</>
                                                            )}
                                                        </td>
                                                        <td className="border-tr-new">{row?.name ? row?.name : "-"}</td>
                                                        <td className="border-tr-new">{row?.contactNo ? row?.contactNo : "-"}</td>
                                                        <td className="border-tr-new">{row?.propertyImgRejectCount ? row?.propertyImgRejectCount : 0} </td>
                                                        <td className="border-tr-new">{row?.propertyNotFoundImgRejectCount ? row?.propertyNotFoundImgRejectCount : 0}</td>
                                                        <td className="border-tr-new">{row?.isNoticeImgRejectCount ? row?.isNoticeImgRejectCount : 0}</td>
                                                        <td className="border-tr-new">{row?.isMeetingPersonImgRejectCount ? row?.isMeetingPersonImgRejectCount : 0}</td>
                                                        <td className="border-tr-new">{row?.propertyVisitCount ? row?.propertyVisitCount : 0}</td>
                                                    </tr>
                                                );
                                            })
                                            : <div>No Data Found</div>
                                    )}
                                </tbody>
                                <tfoot>
                                    {contractor !== undefined && contractor?.data?.length > 0 ? (
                                        <tr className="sum-row">
                                            <td colSpan="2">
                                                <strong className="m-2">Total Counts :-</strong>
                                            </td>
                                            <td className="border-th-new">

                                            </td>
                                            <td className="border-th-new">

                                            </td>
                                            <td className="border-th-new">
                                                <strong>
                                                    {contractor && contractor.totalPropertyImgRejectCount !== undefined && contractor.totalPropertyImgRejectCount !== null
                                                        ? contractor.totalPropertyImgRejectCount
                                                        : "0"}
                                                </strong>
                                            </td>
                                            <td className="border-th-new">
                                                <strong>
                                                    {contractor && contractor.totalPropertyNotFoundImgRejectCount !== undefined && contractor.totalPropertyNotFoundImgRejectCount !== null
                                                        ? contractor.totalPropertyNotFoundImgRejectCount
                                                        : "0"}
                                                </strong>
                                            </td>
                                            <td className="border-th-new">
                                                <strong>
                                                    {contractor && contractor.totalIsNoticeImgRejectCount !== undefined && contractor.totalIsNoticeImgRejectCount !== null
                                                        ? contractor.totalIsNoticeImgRejectCount
                                                        : "0"}
                                                </strong>
                                            </td>
                                            <td className="border-th-new">
                                                <strong>
                                                    {contractor && contractor.totalIsMeetingPersonImgRejectCount !== undefined && contractor.totalIsMeetingPersonImgRejectCount !== null
                                                        ? contractor.totalIsMeetingPersonImgRejectCount
                                                        : "0"}
                                                </strong>
                                            </td>
                                            <td className="border-th-new">
                                                <strong>
                                                    {contractor && contractor.totalPropertyVisitCount !== undefined && contractor.totalPropertyVisitCount !== null
                                                        ? contractor.totalPropertyVisitCount
                                                        : "0"}
                                                </strong>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tfoot>
                            </Table>
                        </div>
                    </div>
                </Row>
            </Container >
        </div >
    );
};

export default GatLipikReportAnalysis;
